<template>
  <div class="setUser-table">
    <div
      v-for="(item, index) in tabs"
      :key="index"
      :class="{
        'setUser-tap-left': index === 0,
        'setUser-tap-right': index !== 0 || index !== tabs.length - 1,
        'setUser-tap-Strategy': index === tabs.length,
        'setUser-overall': actived === index,
        'setUser-Single': !(actived === index),
      }"
      @click="changeListShow(index)"
    >
      {{ item }}
    </div>
  </div>
</template>
<script>
export default {
  name: 'TabBar',
  props: {
    actived: {
      type: Number,
    },
  },
  data() {
    return {
      tabs: [
        // '公众号设置',
        // '管理员设置',
        '策略设置',
        '标签设置',
        '企业设置',
        '会议设置',
        '注册认证设置',
        '外部应用设置',
      ],
    };
  },
  methods: {
    changeListShow(index) {
      this.$emit('changeListShow', index);
    },
  },
};
</script>
<style lang="scss" scoped>
.setUser-table {
  margin-top: 24px;
  width: 100%;
  height: 48px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  .setUser-tap-left {
    cursor: pointer;
    width: 108px;
    height: 48px;
    letter-spacing: 0;
    text-align: center;
    border-radius: 8px 0 0 0;
    line-height: 48px;
    float: left;
    font-weight: bold;
    font-size: 16px;
  }
  .setUser-tap-right {
    cursor: pointer;
    width: 108px;
    height: 48px;
    letter-spacing: 0;
    text-align: center;
    line-height: 48px;
    float: left;
    font-weight: bold;
    font-size: 16px;
  }
  .setUser-tap-Strategy {
    cursor: pointer;
    width: 108px;
    height: 48px;
    letter-spacing: 0;
    text-align: center;
    border-radius: 0 8px 0 0;
    line-height: 48px;
    float: left;
    font-weight: bold;
    font-size: 16px;
  }
  .setUser-overall {
    background: rgba(47, 150, 255, 0.08);
    border: 1px solid #2f96ff;
    color: #2f96ff;
    font-size: 16px;
    font-weight: bold;
  }
  .setUser-Single {
    border: 1px solid rgba(0, 0, 0, 0.07);
    color: #606266;
    font-weight: bold;
    font-size: 16px;
  }
}
</style>
